export const GET_POSTS = '/posts';
export const GET_POST_DETAILS = '/posts';
